<template>
  <v-card>
    <div
      v-for="(cons, i) in $store.state.consignes"
      :key="i"
      class="pt-3 mb-3"
    >
      <ecocup-counter
        :value="cons.consigne.number"
        :title="cons.consigne.Libelle"
        @add="$store.dispatch('addConsigne', cons.consigne.IDArticle)"
        @del="$store.dispatch('delConsigne', cons.consigne.IDArticle)"
      />
      <v-divider class="pb-3" />
      <ecocup-counter
        :value="cons.deconsigne.number"
        :title="cons.deconsigne.Libelle"
        @add="$store.dispatch('addDeconsigne', cons.deconsigne.IDArticle)"
        @del="$store.dispatch('delDeconsigne', cons.deconsigne.IDArticle)"
      />
    </div>
  </v-card>
</template>

<script>
import EcocupCounter from './EcocupCounter'

export default {
  name: 'Ecocup',

  components: {
    EcocupCounter
  }
}
</script>
